import { TAstrologyApiRes } from "../types/astrology-types.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const astrologyApiCall = async () => {
  const response = await request<TAstrologyApiRes>({
    method: "POST",
    url: API_PATHS.astrology,
    data: {
      language: "English",
    },
  });
  return response.data;
};
